import {useContext, useEffect, useState} from "react";
import {AppContext} from "../contexts/appContext";

export const useFiles = () => {
  const [filesArray, setFilesArray] = useState([]);
  const context = useContext(AppContext);
  const { filesContext } = context;

  useEffect(() => {
    setFilesArray(filesContext.getFiles())
  }, [])

  return filesArray
}

